/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
/* eslint camelcase: ["error", {allow: ["top_nr"]}] */
/* global globals */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { withResizeDetector } from 'react-resize-detector/build/withPolyfill';

import MemberStore from '../../stores/MemberStore';
import cx from '../../utils/cx';
import ImageSvg from '../image/ImageSvg';

const ReactPropTypes = PropTypes;

function removeExtension(filename) {
  return filename.substr(0, filename.lastIndexOf('.')) || filename;
}

function getStateFromStores(member, memberId) {
  return {
    member: member || MemberStore.get(memberId),
    myId: MemberStore.getMyID(),
  };
}

class MemberImage extends React.Component {
  state = getStateFromStores(this.props.member, this.props.memberId);

  imageSizes = get(globals, 'imageSizes', {});

  componentDidMount() {
    MemberStore.addChangeMemberListener(this.onChange);
  }

  componentWillUnmount() {
    MemberStore.removeChangeMemberListener(this.onChange);
  }

  /**
   * Event handler for 'change' events coming from the stores
   */
    onChange = () => {
      this.setState(getStateFromStores(this.props.member, this.props.memberId));
    };

    getNextSize = (width) => {
      const { imageSizes } = this;
      const sizeKeys = Object.keys(imageSizes).reverse();

      let biggestAvailable = null;

      for (let i = 0; i < sizeKeys.length; i += 1) {
        const size = sizeKeys[i];
        if (imageSizes[size].crop) {
          if (imageSizes[size].width > width) {
            return size;
          }

          biggestAvailable = size;
        }
      }

      return biggestAvailable;
    };

    render() {
      let memberImageUrl = '';
      let isOnline = false;
      let isHighlighted = false;

      const { member, myId } = this.state;
      let { status } = member;

      //
      if (Object.prototype.hasOwnProperty.call(member, 'admin') && !member.image) {
        status = member.admin.status;
      }

      const {
        top_nr,
        type,
        autosize,
        hideIcons,
        width,
        vipOn,
        vipIcon, // show vip icon true/false
        hideOnline,
        hideHighlighted,
      } = this.props;

      //
      if (vipOn) {
        memberImageUrl = `${globals.staticImageUri}profile/blank-vip.png`;
      } else if (status === 'deleted' || status === 'banned') {
        memberImageUrl = `${globals.staticImageUri}profile/deleted.png`;
      } else if (status === 'admin') {
        memberImageUrl = `${globals.staticImageUri}profile/admin.png`;
      } else { // active lietotājs
        let { sex } = member;

        if (sex) {
          sex = sex.toLowerCase();
        }

        if (member.image) {
          let imageType = type;
          if (imageType === 'xs') {
            imageType = 's';
          }
          if (imageType === 'xm') {
            imageType = 'o-m';
          }

          if (width) {
            const realWidth = width * window.devicePixelRatio;
            if (realWidth > this.imageSizes[imageType].width) {
              imageType = this.getNextSize(realWidth);
            }
          }

          // TODO Diezgan apšaubāmi, bet pagaidām.. gcloud bildēm tagad ir īsāks nosaukums..
          if (member.image.split('').length < 30) {
            memberImageUrl = `${globals.gcloudUri}${imageType}/${member.image}?c=1`;
          } else {
            memberImageUrl = `${globals.imagesBaseUri}images/get/${imageType}/${removeExtension(member.image)}/${sex}`;
          }
        } else {
          let filename = 'blank';
          if (sex) {
            filename += `-${sex}`;
          }
          memberImageUrl = `${globals.staticImageUri}profile/${filename}.png`;
        }

        // savam profilam neliek online pazīmi
        if (!hideOnline && member.online && member._id !== myId) {
          isOnline = true;
        }

        // savam profilam neliek highlighted pazīmi
        if (!hideHighlighted && member.highlighted && member._id !== myId) {
          isHighlighted = true;
        }
      }

      const memberImageNumber = function memberImageNumber() {
        if (top_nr == null) {
          return ('');
        }

        return (<span className="memberImage-number">{top_nr}</span>);
      };

      const memberIcons = function memberIcons() {
        const icons = [];

        if (member.was_visited_by_me) {
          icons.push([
            <span key="was_visited_by_me" className="memberImage-icon">
              <span className="vcenter">
                <span className="vcenter-inner">
                  <ImageSvg svg="icon-watched-2" iconClass="icon icon--watched-2" />
                </span>
              </span>
            </span>,
          ]);
        }

        if (member.was_messaged_by_me) {
          icons.push([
            <span key="was_messaged_by_me" className="memberImage-icon">
              <span className="vcenter">
                <span className="vcenter-inner">
                  <ImageSvg svg="icon-chat" iconClass="icon icon--chat" />
                </span>
              </span>
            </span>,
          ]);
        }

        if (member.favorite) {
          icons.push([
            <span key="favorite" className="memberImage-icon memberImage-icon-heart-2">
              <span className="vcenter">
                <span className="vcenter-inner">
                  <ImageSvg svg="icon-star" iconClass="icon icon--star" />
                </span>
              </span>
            </span>,
          ]);
        }

        if (member.image_count > 1) {
          icons.push([
            <span key="photos" className="memberImage-icon memberImage-icon-photos">
              <span className="vcenter">
                <span className="vcenter-inner">
                  <ImageSvg svg="icon-photos" iconClass="icon icon--photos" />
                </span>
              </span>
            </span>,
          ]);
        }

        if (icons.length < 1) {
          return ('');
        }

        return (
          <div className="memberImage-iconContainer">
            {icons}
          </div>
        );
      };

      return (
        <div
          className={cx([
            ['imagesThumb-image imagesThumb-image--auto', autosize],
            [`memberImage memberImage--${type}`, !autosize],
            ['is-online', isOnline],
            ['is-vip-icon', vipIcon],
            ['is-highlighted', isHighlighted],
          ])}
        >
          {vipIcon && (
            <span className="memberImage-vipIcon">
              <img src={`${globals.staticImageUri}/premium_icon.png`} alt="VIP" />
            </span>
          )}
          <img
            className="memberImage-item"
            alt=""
            src={memberImageUrl}
            // style={width ? { height: `${width * 4 / 3}px` } : {}}
          />
          {!hideIcons && memberIcons()}
          {memberImageNumber()}
        </div>
      );
    }
}

MemberImage.propTypes = {
  member: PropTypes.shape({}),
  memberId: ReactPropTypes.string,
  type: ReactPropTypes.string,
  top_nr: ReactPropTypes.number,
  hideIcons: ReactPropTypes.bool,
  autosize: ReactPropTypes.bool,
  width: ReactPropTypes.number,
  vipOn: ReactPropTypes.bool,
  hideOnline: ReactPropTypes.bool,
  hideHighlighted: ReactPropTypes.bool,
};

MemberImage.defaultProps = {
  member: null,
  memberId: null,
  type: 's',
  top_nr: null,
  hideIcons: false,
  autosize: false,
  width: null,
  vipOn: false,
  hideOnline: false,
  hideHighlighted: false,
};

module.exports = withResizeDetector(MemberImage);
